// types
import { isRequestError } from "api/types/requestsError.types";

export const parseRequestError = (error: unknown): never => {
  if (isRequestError(error)) {
    const { response } = error;
    throw new Error(response.message);
  }
  throw new Error("Произошла серверная ошибка, повторите попытку позже");
};
